import React, { useEffect } from 'react'
import firebase from '../firebase'
import { bool } from 'prop-types'
import { StyledMenu } from './Menu.styled'
import { Route, NavLink, withRouter } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'
import MenuList from '@material-ui/core/MenuList'
import MenuItem from '@material-ui/core/MenuItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import DashboardIcon from '@material-ui/icons/Dashboard'
import PersonIcon from '@material-ui/icons/Person'
import SettingsIcon from '@material-ui/icons/Settings'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import HistoryIcon from '@material-ui/icons/History'
import PublishIcon from '@material-ui/icons/Publish'
import Typography from '@material-ui/core/Typography'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
  paddingTop: {
    padding: theme.spacing(2),
  },
}))

const HamburgerMenu = ({ open, setOpen, ...props }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const isHidden = open ? true : false

  const handleClose = () => {
    setOpen(!open)
  }

  useEffect(() => {
    localStorage.setItem('menuopen', open)
  }, [open])

  return (
    <Route render={() => (
      <StyledMenu open={open} aria-hidden={!isHidden} {...props}>
        <MenuList>
          <MenuItem className={classes.paddingTop}></MenuItem>
          <MenuItem component={NavLink} to="/dashboard" onClick={handleClose} activeclassname="Mui-selected" >
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <Typography variant="inherit">{t('dashboard.label')}</Typography>
          </MenuItem>

          <MenuItem component={NavLink} to="/backups" onClick={handleClose} activeclassname="Mui-selected" >
            <ListItemIcon>
              <HistoryIcon />
            </ListItemIcon>
            <Typography variant="inherit">{t('history.label')}</Typography>
          </MenuItem>

          <MenuItem component={NavLink} to="/upload" onClick={handleClose} activeclassname="Mui-selected" >
            <ListItemIcon>
              <PublishIcon />
            </ListItemIcon>
            <Typography variant="inherit">{t('upload.label')}</Typography>
          </MenuItem>

          <MenuItem component={NavLink} to="/account" onClick={handleClose} activeclassname="Mui-selected" >
            <ListItemIcon>
              <PersonIcon />
            </ListItemIcon>
            <Typography variant="inherit">{t('account.label')}</Typography>
          </MenuItem>

          <MenuItem component={NavLink} to="/settings" onClick={handleClose} activeclassname="Mui-selected" >
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <Typography variant="inherit">{t('settings.label')}</Typography>
          </MenuItem>

          <MenuItem
            onClick={() => {
              logout()
            }}
          >
            <ListItemIcon>
              <ExitToAppIcon/>
            </ListItemIcon>
            <Typography variant="inherit" noWrap style={{ textTransform: 'uppercase', letterSpacing: '0.2rem' }}>
              {t('logout.label')}
            </Typography>
          </MenuItem>
        </MenuList>
      </StyledMenu >
    )}
    />
  )
  async function logout() {
    await firebase.logout()
    window.location.href = '/'
  }
}

HamburgerMenu.propTypes = {
  open: bool.isRequired,
}

export default withRouter(HamburgerMenu)